declare global {
	interface Window {
		API_URL?: string;
		SENTRY_DSN?: string;
		SENTRY_TRACES_SAMPLE_RATE?: number;
		SENTRY_REPLAYS_SESSION_SAMPLE_RATE?: number;
		SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE?: number;
	}
}

export const HTTP_HOST = window.API_URL
	? window.API_URL
	: import.meta.env.VITE_API_URL;
export const HOST = window.location.protocol + '//' + window.location.host;
